import { FlexRow } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import { ViewAccordionForNonPublic, ViewCategory } from "./CustomViewDialogLeftPanelAccordion";

export const CustomViewDialogRoleBasedViews: FC<{}> = observer(() => {
	const {
		customViewStore: { roleItems },
	} = useCustomViewDialogStore();

	return (
		<>
			{roleItems.map((item) => (
				<FlexRow 
					data-csi-automation="CustomViewDialogRoleBasedViews"
					data-csi-custom-view-party-id={item.url} 
					key={item.url}
				>
					<ViewAccordionForNonPublic
						category={ViewCategory.ROLE_BASED}
						isPersonal={false}
						nonGlobalCustomViewItem={item}
					/>
				</FlexRow>
			))}
		</>
	);
});

export default CustomViewDialogRoleBasedViews;